import React from 'react';
import { Navigate } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { authStore } from '../stores/AuthStore';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRole?: string[];
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = observer(
  ({ children, requiredRole }) => {

    if (authStore.isLoading) {
      return <div style={{ padding: '20px' }}>Loading...</div>;
    }

    // if (!authStore.isAuthenticated || !authStore.user) {
    //   return <Navigate to="/login" replace />;
    // }

    // if (requiredRole && !requiredRole.includes(authStore.user.role)) {
    //   return <Navigate to="/calendar" replace />;
    // }

    return <>{children}</>;
  }
);
